(() => {
  const apiBaseUrl = `${window.location.protocol === 'https:' ? 'https' : 'http'}://informationcollection.benyuan1.com/api/trendFavorite`;

  const normaliseApiResult = (result) => result?.data && typeof result.data === 'object' && 'success' in result.data
    ? result.data
    : result;

  const getRandomAddition = (trendId) => {
    const settings = window.TrendFavoriteCountSettings || {};
    const maximum = Math.max(0, Math.floor(Number(settings.randomAdditionMax) || 0));
    if (!settings.randomAdditionEnabled || !maximum || !trendId) return 0;

    const hash = [...String(trendId)].reduce((value, character) => ((value * 31) + character.charCodeAt(0)) >>> 0, 0);
    return hash % (maximum + 1);
  };

  const formatCount = (count) => {
    if (!Number.isFinite(count) || count < 0) return '—';
    if (count < 1000) return String(count);
    if (count < 10000) return `${(count / 1000).toFixed(1).replace(/\.0$/, '')}K`;
    if (count < 1000000) return `${Math.floor(count / 1000)}K`;
    return `${(count / 1000000).toFixed(1).replace(/\.0$/, '')}M`;
  };

  const getSaveButtons = (scope = document) => [...scope.querySelectorAll('[data-seasonal-trends-save], [data-trending-save]')];

  const updateAriaLabel = (button, count) => {
    const title = button.dataset.trendTitle || 'this article';
    const action = button.getAttribute('aria-pressed') === 'true'
      ? `Remove ${title} from saved articles`
      : `Save ${title}`;
    const countDescription = Number.isFinite(count)
      ? (count === 1 ? '1 person has saved this article.' : `${count} people have saved this article.`)
      : 'Save count unavailable.';
    button.setAttribute('aria-label', `${action}. ${countDescription}`);
  };

  const setCount = (button, count) => {
    const countElement = button.querySelector('[data-seasonal-trends-save-count]')
      || button.parentElement?.querySelector('[data-seasonal-trends-save-count]');
    if (!countElement) return;
    const safeCount = Number.isFinite(count) ? Math.max(0, count) : null;
    const displayedCount = safeCount == null ? null : safeCount + getRandomAddition(button.dataset.trendId);
    button.dataset.favoriteCount = safeCount == null ? '' : String(safeCount);
    countElement.textContent = formatCount(displayedCount);
    updateAriaLabel(button, displayedCount);
  };

  const postStats = async (payload) => {
    const response = await fetch(`${apiBaseUrl}/stats`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    const result = await response.json().catch(() => null);
    const apiResult = normaliseApiResult(result);
    if (!response.ok || apiResult?.success !== true) {
      throw new Error(apiResult?.message || result?.message || `Trend stats request failed (${response.status})`);
    }
    return Array.isArray(apiResult.data) ? apiResult.data : [];
  };

  const applyCounts = (scope, countsByTrendId) => {
    getSaveButtons(scope).forEach((button) => {
      const trendId = button.dataset.trendId;
      if (!trendId) return;
      setCount(button, countsByTrendId.get(String(trendId)) ?? 0);
    });
  };

  const refresh = async (scope = document) => {
    const trendIds = [...new Set(getSaveButtons(scope)
      .map((button) => button.dataset.trendId)
      .filter(Boolean))];
    if (!trendIds.length) return;

    try {
      const statistics = await postStats({ trendIds });
      const countsByTrendId = new Map(statistics.map((item) => [String(item.trendId), Number(item.favoriteCount) || 0]));
      applyCounts(scope, countsByTrendId);
    } catch (error) {
      console.warn('Unable to load trend favorite counts.', error);
    }
  };

  const refreshTrend = async (trendId, scope = document) => {
    if (!trendId) return;

    try {
      const statistics = await postStats({ trendIds: [trendId] });
      const statistic = statistics.find((item) => String(item.trendId) === String(trendId));
      const favoriteCount = statistic ? Number(statistic.favoriteCount) || 0 : 0;
      getSaveButtons(scope)
        .filter((button) => button.dataset.trendId === String(trendId))
        .forEach((button) => setCount(button, favoriteCount));
    } catch (error) {
      console.warn('Unable to refresh trend favorite count.', error);
    }
  };

  const adjust = (trendId, delta, scope = document) => {
    getSaveButtons(scope)
      .filter((button) => button.dataset.trendId === String(trendId))
      .forEach((button) => {
        const currentCount = Number(button.dataset.favoriteCount);
        if (!Number.isFinite(currentCount) || button.dataset.favoriteCount === '') return;
        setCount(button, currentCount + delta);
      });
  };

  window.TrendFavoriteCounts = { adjust, refresh, refreshTrend };
})();
